import React from 'react';
import styled, {css} from "styled-components";
import {LayoutWrapper} from 'bukku/components/Layout/LayoutWrapper';

export const StyledLayoutWrapper = styled(props => <LayoutWrapper {...props} />)`

  .ant-collapse-item {
    border: 1px solid #dadada;
  }

  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding: 8px 16px;
    font-weight: 500;
    background: #f0f0f0;
    transition: background 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

    &:hover {
      cursor: pointer;
      background: #e8e8e8;
    }
  }

  .ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding: 12px 12px 4px;
    background: white;
    border-bottom: 1px solid #d9d9d9;
  }

  .ant-list-grid .ant-col > .ant-list-item {
    margin-bottom: 8px;
  }
`;

export const ReportAccountsFormStyled = css`
  .report-accounts-form {
    .select-children-item {
      padding-left: 0 !important;
    }

    .account-name {
      display: none;
    }
  }

  .quantity-tooltip {
    .tooltip-uom {
      bottom: 0;
    }
  }
`;
